import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@ui/lib/utils.js';

export { default as PInput } from './PInput.vue';

const pInputCvaConfig = {
    variants: {
        size: {
            lg: 'h-10 px-4',
            default: 'h-9 px-3',
            sm: 'h-8 px-2',
            xs: 'h-7 px-1 rounded-sm paragraph-xs',
        },
    },
    defaultVariants: {
        size: 'default',
    },
} as const;

export const pInputVariants = cva(
    cn(
        'file:text-foreground',
        'placeholder:text-foreground-muted',
        'selection:bg-surface-primary',
        'selection:text-foreground-on-primary',
        'border-border-default',
        'paragraph-sm',
        'flex',
        'w-full',
        'min-w-0',
        'rounded-lg',
        'border',
        'bg-surface-input',
        'py-1',
        'text-foreground-primary',
        'shadow-xs',
        'transition-[color,box-shadow]',
        'outline-none',
        'file:inline-flex',
        'file:h-7',
        'file:border-0',
        'file:bg-transparent',
        'file:font-medium',
        'disabled:pointer-events-none',
        'disabled:cursor-not-allowed',
        'disabled:opacity-50',
        'focus-visible:border-border-border-4',
        'focus-visible:ring-ring-default',
        'focus-visible:ring-[3px]',
        'aria-invalid:text-foreground-destructive',
        'aria-invalid:ring-ring-error',
        'aria-invalid:border-border-destructive',
    ),
    pInputCvaConfig,
);

export type PInputVariants = VariantProps<typeof pInputVariants>;
export const P_INPUT_SIZES = Object.keys(pInputCvaConfig.variants.size);
export type PInputSize = keyof typeof pInputCvaConfig.variants.size;
export type { PInputProps } from '@ui/components/core/p-input/PInputProps.js';
